import { useEffect, useState } from "react";

const navItems = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
  { label: "Access", href: "#access" },
];

const socials = [
  { icon: "ri-facebook-fill", href: "", label: "Facebook" },
  { icon: "ri-line-fill", href: "", label: "LINE" },
  { icon: "ri-whatsapp-fill", href: "", label: "WhatsApp" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/a35c297e288f6b366b89cee76947f7c3/6fa04e5f89eb63777ba3d39f2af83c0d.png"
            alt="Anniversary Car Event Rental"
            className={`w-24 h-24 object-contain transition-all duration-500 ${scrolled ? "brightness-100" : "brightness-200"}`}
          />
          <div className={`leading-tight ${scrolled ? "text-foreground-950" : "text-background-50"}`}>
            <p className="font-heading text-lg tracking-[0.2em]">Anniversary Car</p>
            <p className="text-[10px] tracking-[0.3em] opacity-80">— Event Rental —</p>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`text-xs tracking-[0.2em] uppercase cursor-pointer transition-colors whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600"
                  : "text-background-50/90 hover:text-accent-300"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:+817069422157"
            className={`text-xs tracking-[0.15em] flex items-center gap-2 whitespace-nowrap cursor-pointer ${
              scrolled ? "text-foreground-700" : "text-background-50"
            }`}
          >
            <i className="ri-phone-line"></i>
            070-6942-2157
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
          aria-label="menu"
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-6 py-6 anim-fade-in">
          <nav className="flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.2em] uppercase text-foreground-800 hover:text-primary-600 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <div className="mt-6 pt-6 border-t border-background-200 flex items-center gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-9 h-9 flex items-center justify-center text-foreground-700 hover:text-primary-600 cursor-pointer"
              >
                <i className={`${s.icon} text-lg`}></i>
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}